import { Component, ViewEncapsulation, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { KeybindService, KEYBOARD_CODES, KeybindDescription } from '~core/services';
import { SignInComponent } from '~auth/components/signin.component';
import { ModalService, RegistrationService } from '~auth/services';

@Component({
  selector: 'uw-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnDestroy {
  @ViewChild('forgotPassword') content;

  forgotPasswordModal: NgbModalRef;
  forgotPassForm: FormGroup;
  showError: boolean = false;
  subscriptions: Subscription[] = [];
  close = new EventEmitter();
  failureResponse: string = '';
  progressVisible: boolean;

  constructor(
    private ngbModal: NgbModal,
    private fb: FormBuilder,
    private keybindService: KeybindService,
    private registrationService: RegistrationService,
    private modalService: ModalService) {

    this.forgotPassForm = this.fb.group({
      email: ['', Validators.compose([Validators.required])]
    });

    this.showError = false;

    this.subscriptions.push(this.keybindService.bind(new KeybindDescription(KEYBOARD_CODES.escape))
      .subscribe(x => this.goBack()));
  }

  isFieldValid(field: string) {
    return !this.forgotPassForm.get(field).valid && this.forgotPassForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-danger': this.isFieldValid(field)
    };
  }

  inputFieldCss(field: string) {
    return {
      'form-control-danger': this.isFieldValid(field)
    };
  }

  requestResetPasswordLink() {
    this.failureResponse = '';
    this.progressVisible = true;
    const email = this.forgotPassForm.get('email').value;
    this.registrationService.forgotPassword(email)
      .take(1)
      .subscribe(r => {
        this.closeModal();
        this.progressVisible = false;
      }, error => {
        this.failureResponse = 'Problem in sending a reset password email. Please contact admin.';
        this.progressVisible = false;
      });
  }

  open() {
    this.forgotPassForm.reset();
    this.forgotPasswordModal = this.ngbModal.open(this.content, {
      keyboard: false,
      backdrop: 'static',
      windowClass: 'forgot-pass-modal'
    });
  }

  closeModal(reason?: string) {
    this.close.emit('CLOSE');
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    this.forgotPasswordModal.close(reason);
  }

  goBack() {
    this.modalService.getModalComponent(SignInComponent);
    this.closeModal('FORGOT');
  }

  ngOnDestroy() {
    this.close.complete();
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/components/forgot-password.component.ts